export default (state, action) => {
  let newFieldValue = {
    ...state
  };

  newFieldValue[`${action.instanceKey}_isSubmitting`] = false;

  return newFieldValue;
};
